export default __webpack_public_path__ + "static/media/dashboard.619a4411.svg";